import { useCopyToClipboard } from '../../../../../hooks/useCopyToClipboard';
import CopyIcon from '../../../Icons/CopyIcon';
import { Box, Typography } from '@coolblue-development/freddy';

interface CopyableEmailAddressProps {
  // Either a bare address or "Name <address>"; only the address is copied.
  text: string;
  'data-testid'?: string;
}

const CopyableEmailAddress = ({ text, 'data-testid': dataTestId }: CopyableEmailAddressProps): JSX.Element => {
  const { copied, copy } = useCopyToClipboard();

  return (
    <Box
      onClick={e => {
        e.stopPropagation();
        copy(text.match(/<([^<>]+)>$/)?.[1] ?? text);
      }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        '&& > *': { marginBottom: '0px' },
        cursor: 'pointer',
        opacity: copied ? 0.6 : 1,
        transition: 'opacity 0.2s',
        '&:hover': { opacity: 0.75 }
      }}
    >
      <Typography variant="caption" color="subtle" data-testid={dataTestId} fontWeight={500}>
        {copied ? 'Copied!' : text}
      </Typography>
      <CopyIcon color="#666" />
    </Box>
  );
};

export default CopyableEmailAddress;
